import PacienteProntuario from "@/model/PacienteProntuario";
import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    Listar: async () => {
        const response = await httpClient.get(`/PacienteProntuario/listar`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarProfissionalLogado: async (pLogado: boolean) => {
        const response = await httpClient.get(`/PacienteProntuario/listar?exibirLogado=${pLogado}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorIdPaciente: async (pId: number) => {
        const response = await httpClient.get(`/PacienteProntuario/listarPorPaciente?idPaciente=${pId}&orderBy= p.Data desc`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    listarPorProfissional: async (pId: number) => {
        const response = await httpClient.get(`/PacienteProntuario/listarPorProfissional?idProfissional=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorIdProntuario: async (pId: number) => {
        const response = await httpClient.get(`/PacienteProntuario/id?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (pacienteProntuario: PacienteProntuario) => {
        const response = await httpClient.post(`/PacienteProntuario/inserir`, pacienteProntuario);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (pacienteProntuario: PacienteProntuario) => {
        const response = await httpClient.post(`PacienteProntuario/alterar`, pacienteProntuario);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pId: number) => {
        const response = await httpClient.post(`PacienteProntuario/excluir?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
});